<div class="input-group">
    <select class="custom-select" [(ngModel)]="selectedDesk">
        <option *ngFor="let desk of desks" [ngValue]="desk">{{ desk.fullName }}</option>
    </select>
    <div class="input-group-append">
        <button class="btn btn-primary" (click)="redirect()">{{ 'console.redirect' | translate }}</button>
    </div>
</div>
